import { useState } from 'react';

const faqs = [
  {
    q: '17爆料投稿之后多久会有回应？',
    a: '编辑部通常在收到投稿后1至3个工作日内完成初步审核，并通过你预留的联系方式（如有）与你取得联系。如需补充材料或进一步核实，我们会主动告知。匿名投稿无法逐一回复，但每条线索都会被认真阅读。',
  },
  {
    q: '我可以匿名投稿吗？投稿信息会保密吗？',
    a: '可以完全匿名。17爆料支持匿名提交，你的姓名、联系方式均不是必填项。平台承诺对所有投稿人信息严格保密，不向任何第三方透露信源。线索保密是我们的基本原则。',
  },
  {
    q: '什么类型的线索会被核实发布？',
    a: '我们优先关注具有公共利益价值的线索，包括但不限于：消费维权、食品安全、物业纠纷、交通安全、网络诈骗、社会民生和行业黑料。如果你对某条线索是否符合标准有疑问，直接投稿即可，编辑部会做出判断。',
  },
  {
    q: '投稿线索未被发布，是因为什么原因？',
    a: '通常有以下几种情况：无法核实关键事实、线索信息不完整、内容不具备公共利益价值，或类似报道近期已发布。我们鼓励你提供更多佐证材料或补充说明，以提高核实成功率。',
  },
  {
    q: '17爆料私信渠道和在线投稿有什么区别？',
    a: '在线投稿表单适合提交结构化线索，支持上传图片、视频和文件附件，处理效率更高。私信渠道适合在投稿前先沟通、提问，或对附件和格式有特殊要求的情况。两种方式都受到同等保密保护。',
  },
  {
    q: '如何知道自己的线索被核实发布了？',
    a: '如果你在投稿时留下了联系方式，编辑部会在发布前或发布后通知你。你也可以在「已核实报道」栏目中搜索相关关键词，查找是否已有相关报道。',
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="bg-background-100 py-14 md:py-20" aria-labelledby="faq-heading">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 id="faq-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm">关于17爆料投稿、私信和核实流程的常见疑问</p>
        </div>

        <div className="flex flex-col divide-y divide-background-200">
          {faqs.map((faq, i) => (
            <div key={i} className="py-4">
              <button
                className="w-full flex items-center justify-between gap-3 text-left cursor-pointer group"
                onClick={() => setOpen(open === i ? null : i)}
                aria-expanded={open === i}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {faq.q}
                </h3>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-500">
                  <i className={`ri-${open === i ? 'subtract' : 'add'}-line`} />
                </span>
              </button>
              {open === i && (
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed pr-8">
                  {faq.a}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Schema.org FAQPage JSON-LD is rendered separately in page.tsx */}
      </div>
    </section>
  );
}